import React from 'react';
import Autosuggest from 'react-autosuggest';
import { withHandlers, withState, compose, pure } from 'recompose';

const suggestions = withState('suggestions', 'setSuggestions', ({ options }) => options || []);

const getSuggestions = withHandlers({
  getSuggestions: ({ options }) => (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : options.filter(lang =>
        lang.name && lang.name.toLowerCase().slice(0, inputLength) === inputValue
    );
  }
})

const handlers = withHandlers({
  onChange: ({ onValueChange }) => (event, { newValue }) => {
    onValueChange(newValue)
  },
  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested: ({ setSuggestions, getSuggestions }) => ({ value }) => {
    setSuggestions(getSuggestions(value));
  },
  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested: ({ setSuggestions }) => () => {
    setSuggestions([]);
  }
})


const getSuggestionValue = suggestion => suggestion.name;

const renderSuggestion = suggestion => (
  <div>
    {suggestion.name}
  </div>
);

const AutoCompleteInput = ({
  value,
  suggestions,
  onChange,
  onSuggestionsFetchRequested,
  onSuggestionsClearRequested,
  placeholder
}) => {
  // Autosuggest will pass through all these props to the input.
  const inputProps = {
    placeholder,
    value,
    onChange: onChange,
    className: 'form-control'
  };
  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
    />
  );
}

export default compose(
  suggestions,
  getSuggestions,
  handlers,
  pure
)(AutoCompleteInput);
